export default {"src":"/_next/static/media/messe-hamburg-logo.13bce844.svg","height":134,"width":515};